/*
  Collapses the consent banner's body copy to two lines behind a "lees meer"
  toggle, and keeps the banner's clicks from closing the Klaviyo popup.

  The copy is written in Instellingen > Klantprivacy and is long by default --
  seven lines on a phone, which pushed the buttons well down the screen. It
  cannot be shortened from the theme, so it is shortened visually here.

  The banner is built client-side and can appear at any moment, so this watches
  for it rather than assuming it exists at load.
*/
(function () {
  var config = document.getElementById('cookie-banner-js');
  var MORE = (config && config.dataset.readMore) || 'Read more';
  var LESS = (config && config.dataset.readLess) || 'Read less';
  var CLAMPED = 'cookie-banner--clamped';

  function enhance(banner) {
    if (banner.dataset.clampReady) return;

    var body = banner.querySelector('.shopify-pc__banner__body');
    var text = body && body.querySelector('p');
    if (!text) return;

    banner.dataset.clampReady = 'true';
    banner.classList.add(CLAMPED);

    // Short copy, or a locale that happens to fit: leave it alone rather than
    // offering a toggle that reveals nothing.
    if (text.scrollHeight <= text.clientHeight + 1) {
      banner.classList.remove(CLAMPED);
      return;
    }

    var row = document.createElement('div');
    row.className = 'cookie-banner__more-row';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'cookie-banner__more';
    toggle.textContent = MORE;
    toggle.setAttribute('aria-expanded', 'false');
    row.appendChild(toggle);

    // The privacy policy link sits at the end of the sentence, so the clamp
    // hides it. Repeat it next to the toggle so the one link that has to be on
    // this first layer stays visible without expanding anything. The CSS shows
    // exactly one of the two at a time.
    var policy = text.querySelector('a');
    if (policy) {
      var repeat = policy.cloneNode(true);
      repeat.removeAttribute('id');
      repeat.className = 'cookie-banner__policy';
      row.appendChild(repeat);
    }

    toggle.addEventListener('click', function () {
      var expanded = banner.classList.toggle(CLAMPED) === false;
      toggle.textContent = expanded ? LESS : MORE;
      toggle.setAttribute('aria-expanded', String(expanded));
    });

    body.appendChild(row);
  }

  // Klaviyo closes its popup on any click outside it, and the banner sits on
  // top of that popup -- so "Accepteren" also dismissed the signup form, and
  // Klaviyo recorded it as closed by the visitor (disabledForms), which keeps
  // it away for days. Clicks on the banner and the preferences dialog stop
  // here. Shopify's own handlers sit on the controls themselves, so they still
  // fire.
  var CONTAINED = ['click', 'mousedown', 'mouseup', 'pointerdown', 'pointerup', 'touchstart', 'touchend'];

  function contain(element) {
    if (!element || element.dataset.clicksContained) return;
    element.dataset.clicksContained = 'true';
    CONTAINED.forEach(function (type) {
      element.addEventListener(
        type,
        function (event) {
          event.stopPropagation();
        },
        { passive: true }
      );
    });
  }

  function scan() {
    var banner = document.getElementById('shopify-pc__banner');
    if (banner) {
      enhance(banner);
      contain(banner);
    }
    contain(document.getElementById('shopify-pc__prefs'));
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true });
})();
